// extracted by mini-css-extract-plugin
export var howWorks = "howWorks-module--how-works--a7d44";
export var howWorks__col = "howWorks-module--how-works__col--48871";
export var howWorks__row = "howWorks-module--how-works__row--d3d85";
export var howWorks__subtitle = "howWorks-module--how-works__subtitle--3994b";
export var howWorks__text = "howWorks-module--how-works__text--eee9b";
export var howWorks__textSmall = "howWorks-module--how-works__text--small--768ea";
export var howWorks__title = "howWorks-module--how-works__title--30472";
export var howWorks__wrapper = "howWorks-module--how-works__wrapper--e1363";